/** 长连接方式 */
// 原方式（不增加断开之后的轮询机制）
// export { connectLong, beforeLong, stopLong, reLong } from './noLoop';
// 新增方式（增加断开之后的轮询机制）
// export { connectLong, beforeLong, stopLong, reLong } from './loop';
import { addPollingMechanism } from '@/shared/screenAndLongLinkConfig';
import * as noLoop from './noLoop';
import * as loop from './loop';
const loopContent = addPollingMechanism ? loop : noLoop;
export const { connectLong, beforeLong, stopLong, reLong } = loopContent;
